import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { constant } from 'app/app.constants';
import {  ActionEnum, IProfitCenter } from 'app/core/interfaces/payor.interface';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PayorProfitCentersService extends ParentService {
  private payorProfitCenters = new BehaviorSubject<{
    action: ActionEnum;
    payorId: number | null ;
    profitCenter: IProfitCenter | null;
  }>({ action: ActionEnum.None, payorId: null, profitCenter: null });
  payorProfitCenters$ = this.payorProfitCenters.asObservable();

  private validateEmailsDomains = new BehaviorSubject<boolean>(false);
  validateEmailsDomains$ = this.validateEmailsDomains.asObservable();

  constructor(private http: Http) {
    super();
  }

  getProfitCenterByPayorId(payorId: number, showInactive: boolean) {
    return this.http
      .get(
        `${constant.URL_GET_PAYOR_PROFIT_CENTER}/${payorId}/${showInactive}`,
        this.getHeader()
      )
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  postProfitCenter(profitCenter: IProfitCenter) {
    return this.http.post(constant.URL_POST_PAYOR_PROFIT_CENTER, profitCenter, this.headerPost())
      .map((res) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  putProfitCenter(profitCenter: IProfitCenter) {
    return this.http.put(constant.URL_PUT_PAYOR_PROFIT_CENTER, profitCenter, this.headerPost())
      .map((res) => res.json())
      .catch(error => Observable.throw(error.json()));
  }


  changeStatusPayorProfitCenter(profitCenterId: number) {
    return this.http.put(`${constant.URL_POST_CHANGE_STATUS_CENTER}/${profitCenterId}`, null , this.headerPost())
      .map((res) => res.json())
      .catch(error => Observable.throw(error.json()));
  }


  setPayorProfitCenters(
    action: ActionEnum,
    PayorId: number = null,
    profitCenter: IProfitCenter = null
  ) {
    this.payorProfitCenters.next({
      action,
      payorId: PayorId,
      profitCenter: profitCenter,
    });
  }

  setValidateEmailsDomains(validate: boolean) {
    this.validateEmailsDomains.next(validate);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/payors/payor-profit-centers/payor-profit-centers.service.ts